import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import type { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';

export interface DonutSegment {
  name: string;
  value: number;
  color: string;
}

export interface DonutChartWrapperProps {
  /** Chart data segments */
  data: DonutSegment[];
  /** Chart height in pixels */
  height?: number;
  /** Inner radius for the donut hole (percentage or pixels) */
  innerRadius?: number | string;
  /** Outer radius (percentage or pixels) */
  outerRadius?: number | string;
  /** Custom tooltip formatter */
  tooltipFormatter?: (value: ValueType | undefined, name: NameType | undefined) => [React.ReactNode, NameType] | React.ReactNode;
}

/**
 * Recharts PieChart (donut) wrapper with standard OUTFRONT styling.
 */
export function DonutChartWrapper({
  data,
  height = 300,
  innerRadius = '55%',
  outerRadius = '80%',
  tooltipFormatter,
}: DonutChartWrapperProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          paddingAngle={2}
          strokeWidth={1}
          stroke="#FFFFFF"
        >
          {data.map((segment, index) => (
            <Cell key={`cell-${index}`} fill={segment.color} fillOpacity={0.85} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #DCDCDC',
            borderRadius: 4,
            fontSize: 13,
          }}
          formatter={tooltipFormatter}
        />
        <Legend
          verticalAlign="bottom"
          iconType="circle"
          wrapperStyle={{ fontSize: 11, fontWeight: 600 }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default DonutChartWrapper;
